
import React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";

export interface PaymentTrendItem {
  id: number;
  period: string;
  month: string;
  year: string;
  cash: number;
  online: number;
  total: number;
  percentageChange: number;
}

interface PaymentTrendsTableProps {
  data: PaymentTrendItem[];
  currentPage: number;
  itemsPerPage: number;
}

const PaymentTrendsTable = ({
  data,
  currentPage,
  itemsPerPage,
}: PaymentTrendsTableProps) => {
  // Calculate current items
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = data.slice(indexOfFirstItem, indexOfLastItem);

  return (
    <Table>
      <TableHeader>
        <TableRow>
          <TableHead>Period</TableHead>
          <TableHead>Month</TableHead>
          <TableHead>Year</TableHead>
          <TableHead className="text-right">Cash</TableHead>
          <TableHead className="text-right">Online</TableHead>
          <TableHead className="text-right">Total</TableHead>
          <TableHead className="text-right">Change %</TableHead>
        </TableRow>
      </TableHeader>
      <TableBody>
        {currentItems.length > 0 ? (
          currentItems.map((item) => (
            <TableRow key={item.id}>
              <TableCell>{item.period}</TableCell>
              <TableCell>{item.month}</TableCell>
              <TableCell>{item.year}</TableCell>
              <TableCell className="text-right font-medium">
                ${item.cash.toLocaleString()}
              </TableCell>
              <TableCell className="text-right font-medium">
                ${item.online.toLocaleString()}
              </TableCell>
              <TableCell className="text-right font-medium">
                ${item.total.toLocaleString()}
              </TableCell>
              <TableCell className="text-right">
                <span
                  className={
                    item.percentageChange > 0
                      ? "text-green-600"
                      : item.percentageChange < 0
                      ? "text-red-600"
                      : ""
                  }
                >
                  {item.percentageChange > 0 ? "+" : ""}
                  {item.percentageChange}%
                </span>
              </TableCell>
            </TableRow>
          ))
        ) : (
          <TableRow>
            <TableCell
              colSpan={7}
              className="h-24 text-center text-muted-foreground"
            >
              No results found.
            </TableCell>
          </TableRow>
        )}
      </TableBody>
    </Table>
  );
};

export default PaymentTrendsTable;
